<!-- Created by 337547038 on 2020/8/14 0014. -->
<template>
  <div class="world">
    <div class="main-title">
      <h3>世界高校专利申请公开量地域分布</h3>
      <div class="tooltip">
        <i class="icon"></i>
        <div class="text">色块颜色的深浅代表中英美日法德对应的国家区域所有高校专利申请公开量的大小，鼠标移动到该区域会显示具体的数值({{yearRange}})</div>
      </div>
    </div>
    <div class="charts map-bg">
      <Map mapType="world" :isMobile="isMobile"></Map>
    </div>
    <div class="main-title">
      <h3>PCT申请量TOP10中国高校</h3>
      <div class="tooltip">
        <i class="icon"></i>
        <div class="text">统计时间区间为{{yearRange}}</div>
      </div>
    </div>
    <div class="charts">
      <Echarts :option="pieOption" :height="isMobile?'250px':'500px'"></Echarts>
    </div>
    <div class="main-title">
      <h3>PCT申请量TOP10世界高校</h3>
      <div class="tooltip">
        <i class="icon"></i>
        <div class="text">统计时间区间为{{yearRange}}</div>
      </div>
    </div>
    <div class="charts">
      <Echarts :option="lineOption" :height="isMobile?'250px':'500px'"></Echarts>
    </div>
    <div class="main-title">
      <h3>中国专利申请量TOP10国外高校</h3>
      <div class="tooltip">
        <i class="icon"></i>
        <div class="text">统计时间区间为{{yearRange}}</div>
      </div>
    </div>
    <div class="charts">
      <Echarts :option="barOption" :height="isMobile?'250px':'500px'"></Echarts>
    </div>
  </div>
</template>

<script>
import Map from '@/components/Map'
import Echarts from '@/components/Echarts'
// import {ShenZhen} from '@/api'
import Query from '@/utils/query'

export default {
  name: "World",
  data() {
    return {
      pieOption: {},
      lineOption: {},
      barOption: {},
      isMobile: false
    }
  },
  mixins: [Query],
  props: {},
  components: {Map, Echarts},
  methods: {
    getChartsPie() {
      this.getAjax(14, data => {
        let min = 10000000
        let max = 0
        data && data.forEach(item => {
          if (item.value > max) {
            max = item.value + 50
          }
          if (item.value < min) {
            min = item.value - 50
          }
        })
        this.pieOption = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c}'
          },
          visualMap: {
            show: false,
            min: min,
            max: max,
            inRange: {
              colorLightness: [0, 1]
            }
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: this.isMobile?'75%':'90%',
              center: ['50%', '50%'],
              data: data.sort(function (a, b) {
                return a.value - b.value;
              }),
              roseType: 'radius',
              label: {
                color: '#a2a27a',
                fontSize: this.isMobile?8:16
              },
              labelLine: {
                lineStyle: {
                  color: '#a2a27a'
                },
                smooth: 0.2,
                length: this.isMobile?5:10,
                length2: this.isMobile?5:20
              },
              itemStyle: {
                color: '#0043c4',
                // shadowBlur: 200,
                //  shadowColor: 'rgba(0, 0, 0, 0.5)'
              },

              animationType: 'scale',
              animationEasing: 'elasticOut',
              animationDelay: function () {
                return Math.random() * 200;
              }
            }
          ]
        }
      })
    },
    getLineOption() {
      this.getAjax(15, data => {
        let yAxis = []
        data = data.sort(function (a, b) {
          return a.value - b.value;
        })
        data && data.forEach(item => {
          yAxis.push(item.name)
        })
        this.lineOption = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          color: ['#36c5c9'],
          legend: {},
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: 0,
            containLabel: true
          },
          xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLabel: {
              fontSize: this.isMobile?10:16
            }
          },
          yAxis: {
            type: 'category',
            data: yAxis,
            axisLabel: {
              fontSize: this.isMobile?10:16
            }
          },
          series: [
            {
              type: 'bar',
              // data: [30, 45, 40, 68, 70, 80, 90, 105, 140, 150]
              data: data
            }
          ]
        }
      })
    },
    getBarOption() {
      this.getAjax(16, data => {
        let xAxis = []
        data && data.forEach(item => {
          xAxis.push(item.name)
        })
        this.barOption = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'none'
            },
            formatter: function (params) {
              return params[0].name + ': ' + params[0].value;
            }
          },
          xAxis: {
            data: xAxis,
            axisTick: {show: false},
            axisLine: {show: false},
            axisLabel: {
              color: '#357afc',
              fontSize: this.isMobile?8:16,
              formatter: (label) => {
                let str = label
                if (!this.isMobile && label.length > 4) {
                  str = label.match(/.{1,4}/g).join('\n')
                }
                if (this.isMobile && label.length > 2) {
                  str = label.match(/.{1,2}/g).join('\n')
                }
                return str
              }
            }
          },
          yAxis: {
            splitLine: {show: false},
            axisTick: {show: false},
            axisLine: {show: false},
            axisLabel: {show: false}
          },
          grid: {
            top: 0,
            left: this.isMobile?15:100,
            right: this.isMobile?10:100,
            bottom: this.isMobile?'70px':'60px'
          },
          color: ['#7aa8ff'],
          series: [
            {
              name: 'hill',
              type: 'pictorialBar',
              barCategoryGap: '-130%',
              symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
              itemStyle: {
                opacity: 0.5
              },
              emphasis: {
                itemStyle: {
                  opacity: 1
                }
              },
              // data: [123, 60, 25, 108, 120, 109, 102, 100, 50, 40],
              data: data,
              z: 10
            }
          ]
        }
      })
    }
  },
  computed: {},
  created(){
    // 判断是否移动端
    this.isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  },
  mounted() {
    this.getChartsPie()
    this.getLineOption()
    this.getBarOption()
  }
}
</script>
